import { Box, BoxProps } from "@mui/material";
import { ReactNode } from "react";

interface ContentBoxProps extends BoxProps {
  children: ReactNode;
}
export function ContentBox({ sx = {}, children, ...boxProps }: ContentBoxProps) {
  return (
    <Box
      sx={{
        backgroundColor: (theme) => theme.palette.background.paper,
        boxShadow:
          "rgba(95, 116, 141, 0.03) 0px 2px 1px -1px, rgba(95, 116, 141, 0.04) 0px 1px 1px 0px, rgba(95, 116, 141, 0.08) 0px 1px 3px 0px",
        padding: "16px",
        border: "none",
        borderRadius: "12px",
        ...sx,
      }}
      {...boxProps}
    >
      {children}
    </Box>
  );
}
